import React, { useEffect, useState } from "react";
import { BiMicrophone } from "react-icons/bi";
/**
 * UI component which takes an array of microphones 
 * and shows them in a select dropdown and passes selected microphone through callback
 */
const MicrophoneDropdown = ({ deviceList, microphoneSelected }) => {
  // select the default microphone from system
  const [selectedDeviceId, setSelectedDeviceId] = useState('default');

  // Update selected device when deviceList changes
  useEffect(() => {
    if (deviceList && deviceList.length > 0) {
      // If the previously selected device is still in the list, keep it selected
      const previouslySelectedDevice = deviceList.find(
        (device) => device.deviceId === selectedDeviceId
      );

      if (previouslySelectedDevice) {
        setSelectedDeviceId(previouslySelectedDevice.deviceId);
        // callback on initialization
        microphoneSelected(previouslySelectedDevice)
      } else {
        // Otherwise, select the last device by default
        const lastDevice = deviceList[deviceList.length - 1];
        setSelectedDeviceId(lastDevice.deviceId);
        // select a new microphone and callback
        microphoneSelected(lastDevice); // Notify callback
      }
    }
  }, [deviceList]);

  // Handle device selection
  const handleDeviceChange = (event) => {
    const deviceId = event.target.value;
    const selectedDevice = deviceList.find((device) => device.deviceId === deviceId);
    setSelectedDeviceId(deviceId);
    // if a new microphone is selected then also callback
    if (selectedDevice) {
      microphoneSelected(selectedDevice); // Notify callback
    }
  };

  return (
    <div className="">
     
      <div className="flex flex-row items-center justify-center">
        {/* Microphone Icon */}
      
     <BiMicrophone className="text-gray-700 text-xl m-1 " />
      <select
        id="microphone-select"
        value={selectedDeviceId || ""}
        onChange={handleDeviceChange}
        className=" block w-full p-2 text-sm bg-white rounded-md  focus:outline-none focus:ring-blue-500 focus:border-blue-500"
      >
        {deviceList && deviceList.length > 0 &&
          deviceList.map((device) => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || "Unnamed Microphone"}
            </option>
          ))
         }
         {(!deviceList || deviceList.length == 0 )  &&
          <option value="" disabled>
            No microphones available
          </option>
        }
      </select>
      
     </div>
    </div>
  );
};

export default MicrophoneDropdown;

{
  /*
   <div>
          <h2 className="text-lg font-bold text-gray-700">Available Microphones</h2>
          <ul className="mt-2 space-y-2">
            {deviceList && deviceList.length>0 &&
            deviceList.map((device) => (
              <li
                key={device.deviceId}
                className="p-2 bg-white border rounded-md shadow-sm"
              >
                {device.label}
              </li>
            ))}
          </ul>
          {deviceList.length === 0 && (
            <p className="text-sm text-gray-500">No devices found.</p>
          )}
        </div>
  */
}